import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getConversionHistoryApi, getConversionDetailsViewApi, getDeleteConversionDetailsApi } from "../../end-points/conversionHistory";

const initialState = {
  loading: false,
  error: null,
  success: false,
  tokenData: null,
};

export const getConversionHistory = createAsyncThunk(
  "conversionHistory/getConversionHistory",
  async (payload, thunkAPI) => {
    try {
      const response = await getConversionHistoryApi(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch profile data"
      );
    }
  }
);

export const getConversionDetailsView = createAsyncThunk(
  "conversionHistory/getConversionDetailsView",
  async (payload, thunkAPI) => {
    try {
      const response = await getConversionDetailsViewApi(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch profile data"
      );
    }
  }
);

export const getDeleteConversionDetails = createAsyncThunk(
  "conversionHistory/getDeleteConversionDetails",
  async (payload, thunkAPI) => {
    try {
      const response = await getDeleteConversionDetailsApi(payload);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || "Failed to fetch profile data"
      );
    }
  }
);

const conversionHistorySlice = createSlice({
  name: "conversionHistory",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getConversionHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getConversionHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.convHistoryData = action.payload;
      })
      .addCase(getConversionHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
        state.success = false;
      })

      .addCase(getConversionDetailsView.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getConversionDetailsView.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.convHistoryDetails = action.payload;
      })
      .addCase(getConversionDetailsView.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
        state.success = false;
      })
      
      .addCase(getDeleteConversionDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDeleteConversionDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.error = null;
        state.deleteConversionDetails = action.payload;
      })
      .addCase(getDeleteConversionDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "An error occurred";
        state.success = false;
      });
  },
});

export default conversionHistorySlice.reducer;